// import React, { useState, useEffect } from 'react';
// import { useNavigate, useParams, useLocation } from 'react-router-dom';
// import topImage from "./img/download.jpeg";
// import logo from "./img/Logo (1).png";
// import OrderTable from './orderTable.js'
// import Refund from '../pages/refundForm.js';
// import OrderForm from '../pages/orderForm.js';
// import { Config } from '../.env.js';
// import axios from 'axios';
// import { useCampaign } from '../pages/context';


// const Card = ({ campaign = "Hello", alignLeft }) => {
//     const { campaignName, managers, image } = campaign;
//     const navigate = useNavigate();
//     const location = useLocation();

//     const [tooltipVisible, setTooltipVisible] = useState(false);
//     const [tooltipContent, setTooltipContent] = useState("");
//     const [product, setProduct] = useState([]); // ✅ safe default
//     const [hasRefundForm, setHasRefundForm] = useState(false);


//     const isSignedUp = localStorage.getItem("isloggedIn") === "true"; // 👈 SIGN-UP CHECK

//     const handleProtectedNavigation = (path) => {
//         if (!isSignedUp) {
//             navigate("/user", { state: { from: location.pathname } }); // redirect to signup with current path
//         } else {
//             navigate(path);
//         }
//     };

//     const handleApplyDeliverables = () => {
//         handleProtectedNavigation(`/order-form/${campaignName}?campaignName=${campaignName}`);
//     };

//     const handleConfirmation = () => {
//         handleProtectedNavigation(`/refund-form/${campaignName}?campaignName=${campaignName}`);
//     };

//     const handleOrders = () => {
//         navigate(`/campaignDetails/${campaignName}?campaignDetails=${campaignName}`);
//     };
//     const countBy = (arr, key) => {
//         return arr.reduce((acc, item) => {
//             const value = item[key];
//             if (value) {
//                 acc[value] = (acc[value] || 0) + 1;
//             }
//             return acc;
//         }, {});
//     };
//     useEffect(() => {
//         const fetchProduct = async () => {
//             try {
//                 const response = await axios.get(`${Config.API_URL}/api/product`, {
//                     params: { campaignName }
//                 });
//                 setProduct(response.data);
//             } catch (error) {
//                 console.error("Error fetching product:", error);
//             }
//         };
//         if (campaignName) {
//             fetchProduct();
//         }
//     }, [campaignName]);
//     useEffect(() => {
//         const fetchRefundFormStatus = async () => {
//             try {
//                 const res = await axios.get(`${Config.API_URL}/api/check-refund-template`, {
//                     params: { campaignName }
//                 });
//                 setHasRefundForm(res.data.exists);
//             } catch (err) {
//                 console.error("Error checking refund form:", err);
//             }
//         };

//         if (campaignName) {
//             fetchRefundFormStatus();
//         }
//     }, [campaignName]);
//     const getProgressWidth = () => {
//         const Participate = true;
//         const PaymentsFormFilled = true;
//         const PaymentsMadeCampaignCompleted = true;
//         if (Participate && !PaymentsFormFilled) return "10%";
//         if (Participate && PaymentsFormFilled && !PaymentsMadeCampaignCompleted) return "33%";
//         if (Participate && PaymentsFormFilled && PaymentsMadeCampaignCompleted) return "100%";
//         return "0%";
//     };
//     const getProgressPercentage = () => {
//         const Participate = true;
//         const PaymentsFormFilled = true;
//         const PaymentsMadeCampaignCompleted = true;
//         if (Participate && PaymentsFormFilled && PaymentsMadeCampaignCompleted) return "100% - Payment Made & Campaign Successfully Completed";
//         if (Participate && PaymentsFormFilled) return "66% - Payments Form Filled";
//         if (Participate) return "33% - Participated";
//         return "0%";
//     };

//     const getIconColor = (step) => {
//         const progressWidth = getProgressWidth();
//         if (step === "Participated" && progressWidth !== "0%") return "blue";
//         if (step === "Payments Form Filled" && (progressWidth === "33%" || progressWidth === "100%")) return "blue";
//         if (step === "Payment Made & Campaign Successfully Completed" && progressWidth === "100%") return "blue";
//         return "black";
//     };
//     const [refundFilled, setRefundFilled] = useState(false);
//     const [alreadyApplied, setAlreadyApplied] = useState(false);
//     const userId = localStorage.getItem("loggedInUserId"); // assuming you save it in localStorage
//     // useEffect(() => {
//     //     console.log("campaignName:", campaignName);
//     //     console.log("loggedInUserId", userId);
//     //     const checkIfUserApplied = async () => {
//     //         try {
//     //             const response = await axios.get(`${Config.API_URL}/api/check-user-application`, {
//     //                 params: {
//     //                     campaignName,
//     //                     userId,
//     //                 }
//     //             });

//     //             console.log("API Response:", response.data);
//     //             setAlreadyApplied(response.data?.hasApplied);
//     //             setRefundFilled(response.data?.hasRefunded);
//     //         } catch (error) {
//     //             console.error("Error checking application status:", error);
//     //         }
//     //     };

//     //     if (campaignName && userId) {
//     //         checkIfUserApplied();
//     //     }
//     // }, [campaignName, userId]);
//     useEffect(() => {
//         const checkUserLimit = async () => {
//             try {
//                 const res = await axios.get(`${Config.API_URL}/api/user-application-count`, {
//                     params: { userId, campaignName }
//                 });

//                 const appliedCount = res.data.count;
//                 const maxItemsPerUser = product[0]?.maxItemsPerUser || 1;

//                 setAlreadyApplied(appliedCount >= maxItemsPerUser); // ✅ Always explicitly set
//             } catch (err) {
//                 console.error("Error checking user application count:", err);
//             }
//         };

//         if (userId && campaignName && product.length > 0 && product[0].maxItemsPerUser) {
//             checkUserLimit();
//         }
//     }, [userId, campaignName, product]);


//     // useEffect(() => {
//     //     const checkStatuses = async () => {
//     //         try {
//     //             // Check if user applied
//     //             const applicationResponse = await axios.get(`${Config.API_URL}/api/check-user-application`, {
//     //                 params: { campaignName, userId }
//     //             });

//     //             if (applicationResponse.data?.applied) {
//     //                 setAlreadyApplied(true);
//     //             }

//     //             // Check if refund form is submitted
//     //             const refundResponse = await axios.get(`${Config.API_URL}/api/check-user-refund`, {
//     //                 params: { campaignName, userId }
//     //             });

//     //             if (refundResponse.data?.refundSubmitted) {
//     //                 setRefundSubmitted(true);
//     //             }

//     //         } catch (error) {
//     //             console.error("Error checking statuses:", error);
//     //         }
//     //     };

//     //     if (campaignName && userId) {
//     //         checkStatuses();
//     //     }
//     // }, [campaignName, userId]);

//     return (
//         <div className='is-max-desktop'>
//             <div className="card-content">
//                 <div className="box" style={{ width: '100%', maxWidth: '450px', margin: '0 auto' }}>
//                     <div style={{
//                         position: 'relative',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'flex-start',
//                         height: '150px',
//                         width: '100%',
//                         backgroundImage: `url(${topImage})`,
//                         backgroundSize: 'cover',
//                         backgroundPosition: 'center',
//                         borderRadius: '4px'
//                     }}>
//                         <img src={logo} alt="Logo" style={{
//                             position: 'absolute',
//                             marginLeft: '10px',
//                             width: '40px',
//                             height: '30px',
//                             top: '110px',
//                             zIndex: 2,
//                         }} />
//                     </div>

//                     <div style={{ marginTop: "20px" }}>
//                         <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//                             <div>
//                                 <p className="has-text-grey-light">Campaign Name</p>
//                                 <p className="has-text-weight-bold">{campaignName}</p>
//                             </div>
//                             <p className='has-text-weight-bold' style={{ marginTop: '10px' }}>
//                                 Total Items For Review : <span style={{ color: '#3273dc' }}>{product?.length || 0}</span>
//                             </p>
//                             {product.length > 0 && product[0].maxItemsPerUser && (
//                                 <p className='has-text-weight-bold' style={{ marginTop: '6px' }}>
//                                     Items a User Can Review : <span style={{ color: '#23d160' }}>{product[0].maxItemsPerUser}</span>
//                                 </p>
//                             )}
//                             <div>
//                                 <p className="has-text-grey-light">Item Name</p>
//                                 {Object.entries(countBy(product, "productName")).map(([name, count], idx) => (
//                                     <p key={idx} className='has-text-weight-bold'>
//                                         {name} ×{count}
//                                     </p>
//                                 ))}


//                             </div>
//                         </div>

//                         <div style={{ marginTop: "20px" }}>
//                             <p className="has-text-grey-light">Available Slots</p>
//                             {product?.slice(0, 10).map((item, index) => (
//                                 <p key={index} className='has-text-weight-bold'>{item.productSlot}</p>
//                             ))}
//                         </div>

//                         <div style={{ marginTop: "20px", position: 'relative' }}>
//                             <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
//                                 <div style={{ textAlign: 'center' }}>
//                                     <i className="fas fa-check-circle" style={{ color: getIconColor("Participated") }}></i>
//                                     <br />Participated
//                                 </div>
//                                 <div style={{ textAlign: 'center' }}>
//                                     <i className="fas fa-pencil-alt" style={{ color: getIconColor("Payments Form Filled") }}></i>
//                                     <br />Payments Form Filled
//                                 </div>
//                                 <div style={{ textAlign: 'center' }}>
//                                     <i className="fas fa-check-double" style={{ color: getIconColor("Payment Made & Campaign Successfully Completed") }}></i>
//                                     <br />Payment Completed
//                                 </div>
//                             </div>
//                             <div style={{ width: '100%', height: '5px', backgroundColor: '#e0e0e0', borderRadius: '5px' }}>
//                                 <div
//                                     onMouseEnter={() => {
//                                         setTooltipVisible(true);
//                                         setTooltipContent(getProgressPercentage());
//                                     }}
//                                     onMouseLeave={() => setTooltipVisible(false)}
//                                     style={{
//                                         width: getProgressWidth(),
//                                         height: '100%',
//                                         backgroundColor: 'black',
//                                         borderRadius: '5px',
//                                         transition: 'width 0.5s ease-in-out'
//                                     }}
//                                 />
//                             </div>
//                             {tooltipVisible && (
//                                 <div style={{
//                                     position: 'absolute',
//                                     bottom: '30px',
//                                     left: `${parseInt(getProgressWidth()) - 50}px`,
//                                     backgroundColor: 'white',
//                                     border: '1px solid #ccc',
//                                     borderRadius: '4px',
//                                     padding: '5px',
//                                     zIndex: 10,
//                                     boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
//                                 }}>
//                                     {tooltipContent}
//                                 </div>
//                             )}
//                         </div>

//                         <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginTop: '20px' }}>
//                             <button onClick={handleOrders} className="button is-small has-text-info">View Campaign Details</button>
//                             <button onClick={handleApplyDeliverables} className="button is-small has-text-info" disabled={alreadyApplied}>Participate</button>
//                             {hasRefundForm && (
//                                 <button onClick={handleConfirmation} className="button is-small has-text-info" disabled={refundFilled}>Add Refund Details</button>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Card;

// import React, { useState, useEffect } from 'react';
// import { useNavigate, useParams, useLocation } from 'react-router-dom';
// import topImage from "./img/download.jpeg";
// import logo from "./img/Logo (1).png";
// import { Config } from '../.env.js';
// import axios from 'axios';

// const Card = ({ campaign = {}, alignLeft }) => {
//     const { campaignName, managers, image, brandName } = campaign;
//     const navigate = useNavigate();
//     const location = useLocation();

//     const [product, setProduct] = useState([]);
//     const [hasRefundForm, setHasRefundForm] = useState(false);
//     const [refundFilled, setRefundFilled] = useState(false);
//     const [appliedMap, setAppliedMap] = useState({});
//     const userId = localStorage.getItem("loggedInUserId");
//     const isSignedUp = localStorage.getItem("isloggedIn") === "true";

//     const handleProtectedNavigation = (path) => {
//         if (!isSignedUp) {
//             navigate("/user", { state: { from: location.pathname } });
//         } else {
//             navigate(path);
//         }
//     };

//     // const handleApplyDeliverables = () => {
//     //     handleProtectedNavigation(`/order-form/${campaignName}?campaignName=${campaignName}`);
//     // };
//     const handleApplyDeliverables = () => {
//         handleProtectedNavigation(`/order-form/${campaignName}?campaignName=${campaignName}&brandName=${brandName}`);
//         console.log("cliked on brandName", brandName);

//     };
//     const handleConfirmation = () => {
//         handleProtectedNavigation(`/refund-form/${campaignName}?campaignName=${campaignName}&brandName=${brandName}`);
//     };

//     const handleOrders = () => {
//         navigate(`/campaignDetails/${campaignName}?campaignDetails=${campaignName}`);
//     };

//     const countBy = (arr, key) => {
//         return arr.reduce((acc, item) => {
//             const value = item[key];
//             if (value) {
//                 acc[value] = (acc[value] || 0) + 1;
//             }
//             return acc;
//         }, {});
//     };
//     const topImageUrl = campaign.brandLogo
//         ? `${Config.API_URL}/${campaign.brandLogo}`
//         : '/fallback.jpg'; // fallback if no brand logo exists
//     useEffect(() => {
//         const fetchProduct = async () => {
//             try {
//                 const response = await axios.get(`${Config.API_URL}/api/product`, {
//                     params: { campaignName }
//                 });
//                 setProduct(response.data);
//             } catch (error) {
//                 console.error("Error fetching product:", error);
//             }
//         };

//         if (campaignName) {
//             fetchProduct();
//         }
//     }, [campaignName]);

//     useEffect(() => {
//         const fetchRefundFormStatus = async () => {
//             try {
//                 const res = await axios.get(`${Config.API_URL}/api/check-refund-template`, {
//                     params: { campaignName }
//                 });
//                 setHasRefundForm(res.data.exists);
//             } catch (err) {
//                 console.error("Error checking refund form:", err);
//             }
//         };

//         if (campaignName) {
//             fetchRefundFormStatus();
//         }
//     }, [campaignName]);

//     // ✅ FIX: Check maxItemsPerUser limit per campaign
//     useEffect(() => {
//         const checkUserLimit = async () => {
//             try {
//                 const res = await axios.get(`${Config.API_URL}/api/user-application-count`, {
//                     params: { userId, campaignName }
//                 });

//                 const appliedCount = res.data.count;
//                 const maxItemsPerUser = product[0]?.maxItemsPerUser || 1;

//                 console.log("Applied:", appliedCount, "Max:", maxItemsPerUser);
//                 console.log("Checking user limit for:", userId, campaignName);

//                 setAppliedMap((prev) => ({
//                     ...prev,
//                     [campaignName]: appliedCount >= maxItemsPerUser
//                 }));
//             } catch (err) {
//                 console.error("Error checking user application count:", err);
//             }
//         };

//         if (userId && campaignName && product.length > 0 && product[0].maxItemsPerUser) {
//             checkUserLimit();
//         }
//     }, [userId, campaignName, product]);

//     return (
//         <div className='is-max-desktop'>
//             <div className="card-content">
//                 <div className="box" style={{ width: '100%', maxWidth: '450px', margin: '0 auto' }}>
//                     {/* --- Banner + Logo --- */}
//                     <div style={{
//                         position: 'relative',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'flex-start',
//                         height: '150px',
//                         width: '100%',
//                         backgroundImage: `url(${topImageUrl})`,
//                         backgroundSize: 'cover',
//                         backgroundPosition: 'center',
//                         borderRadius: '4px'
//                     }}>
//                         <img src={logo} alt="Logo" style={{
//                             position: 'absolute',
//                             marginLeft: '10px',
//                             width: '40px',
//                             height: '30px',
//                             top: '110px',
//                             zIndex: 2,
//                         }} />
//                     </div>

//                     <div style={{ marginTop: "20px" }}>
//                         {/* --- Campaign Info --- */}
//                         <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
//                             <div>
//                                 <p className="has-text-grey-light">Campaign Name</p>
//                                 <p className="has-text-weight-bold">{campaignName}</p>
//                             </div>
//                             <p className='has-text-weight-bold'>
//                                 Total Items For Review : <span style={{ color: '#3273dc' }}>{product?.length || 0}</span>
//                             </p>
//                             {product.length > 0 && product[0].maxItemsPerUser && (
//                                 <p className='has-text-weight-bold'>
//                                     Items a User Can Review : <span style={{ color: '#23d160' }}>{product[0].maxItemsPerUser}</span>
//                                 </p>
//                             )}
//                             <div>
//                                 <p className="has-text-grey-light">Item Name</p>
//                                 {Object.entries(countBy(product, "productName")).map(([name, count], idx) => (
//                                     <p key={idx} className='has-text-weight-bold'>{name}</p>
//                                 ))}
//                             </div>
//                         </div>

//                         {/* --- Slots --- */}
//                         <div style={{ marginTop: "20px" }}>
//                             <p className="has-text-grey-light">Available Slots</p>
//                             {product?.slice(0, 10).map((item, index) => (
//                                 <p key={index} className='has-text-weight-bold'>{item.productSlot}</p>
//                             ))}
//                         </div>

//                         {/* --- Buttons --- */}
//                         <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginTop: '20px' }}>
//                             <button onClick={handleOrders} className="button is-small has-text-info">View Campaign Details</button>
//                             <button
//                                 onClick={handleApplyDeliverables}
//                                 className="button is-small has-text-info"
//                                 disabled={appliedMap[campaignName]} // ✅ FIXED: Disable per campaign
//                                 title={appliedMap[campaignName] ? "You have already submitted the maximum allowed." : ""}
//                             >
//                                 Participate
//                             </button>
//                             {hasRefundForm && (
//                                 <button onClick={handleConfirmation} className="button is-small has-text-info" disabled={refundFilled}>
//                                     Add Refund Details
//                                 </button>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Card;
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import topImage from "./img/download.jpeg";
import logo from "./img/Logo (1).png";
import { Config } from '../.env.js';
import axios from 'axios';

const Card = ({ campaign = {}, alignLeft }) => {
    const { id: campaignId, campaignName, managers, image, brandName } = campaign;
    const navigate = useNavigate();
    const location = useLocation();

    const [product, setProduct] = useState([]);
    const [hasRefundForm, setHasRefundForm] = useState(false);
    const [refundFilled, setRefundFilled] = useState(false);
    const [appliedMap, setAppliedMap] = useState({});
    const userId = localStorage.getItem("loggedInUserId");
    const isSignedUp = localStorage.getItem("isloggedIn") === "true";

    const handleProtectedNavigation = (path) => {
        if (!isSignedUp) {
            navigate("/user", { state: { from: location.pathname } });
        } else {
            navigate(path);
        }
    };

    const handleApplyDeliverables = () => {
        handleProtectedNavigation(`/order-form/${campaignName}?campaignName=${campaignName}&brandName=${brandName}`);
        console.log("cliked on brandName", brandName);

    };

    const handleConfirmation = () => {
        handleProtectedNavigation(`/refund-form/${campaignName}?campaignName=${campaignName}&brandName=${brandName}`);
        console.log(" Clicked on brandName", brandName);

    };

    const handleOrders = () => {
        navigate(`/campaignDetails/${campaignName}?campaignDetails=${campaignName}`);
    };

    const countBy = (arr, key) => {
        return arr.reduce((acc, item) => {
            const value = item[key];
            if (value) {
                acc[value] = (acc[value] || 0) + 1;
            }
            return acc;
        }, {});
    };
    const topImageUrl = campaign.brandLogo
        ? `${Config.API_URL}/${campaign.brandLogo}`
        : '/fallback.jpg'; // fallback if no brand logo exists
    // useEffect(() => {
    //     const fetchProduct = async () => {
    //         try {
    //             const response = await axios.get(`${Config.API_URL}/api/product`, {
    //                 params: { campaignName }
    //             });
    //             setProduct(response.data);
    //             console.log("Product:", response.data);
    //         } catch (error) {
    //             console.error("Error fetching product:", error);
    //         }
    //     };

    //     if (campaignName) {
    //         fetchProduct();
    //     }
    // }, [campaignName]);

    useEffect(() => {
        const fetchProduct = async () => {
            try {
                const response = await axios.get(`${Config.API_URL}/api/product`, {
                    params: { campaignId }, // now campaignId comes from props
                });
                setProduct(response.data);
                console.log("Products for campaign:", campaignId, response.data);
            } catch (error) {
                console.error("Error fetching product:", error);
            }
        };

        if (campaignId) {
            fetchProduct();
        }
    }, [campaignId]);


    useEffect(() => {
        const fetchRefundFormStatus = async () => {
            try {
                const res = await axios.get(`${Config.API_URL}/api/check-refund-template`, {
                    params: { campaignName }
                });
                setHasRefundForm(res.data.exists);
            } catch (err) {
                console.error("Error checking refund form:", err);
            }
        };

        if (campaignName) {
            fetchRefundFormStatus();
        }
    }, [campaignName]);

    // ✅ FIX: Check maxItemsPerUser limit per campaign
    useEffect(() => {
        const checkUserLimit = async () => {
            try {
                const res = await axios.get(`${Config.API_URL}/api/user-application-count`, {
                    params: { userId, campaignName }
                });

                const appliedCount = res.data.count;
                const maxItemsPerUser = product[0]?.maxItemsPerUser || 1;

                console.log("Applied:", appliedCount, "Max:", maxItemsPerUser);
                console.log("Checking user limit for:", userId, campaignName);

                setAppliedMap((prev) => ({
                    ...prev,
                    [campaignName]: appliedCount >= maxItemsPerUser
                }));
            } catch (err) {
                console.error("Error checking user application count:", err);
            }
        };

        if (userId && campaignName && product.length > 0 && product[0].maxItemsPerUser) {
            checkUserLimit();
        }
    }, [userId, campaignName, product]);

    return (
        <div className='is-max-desktop'>
            <div className="card-content">
                <div className="box" style={{ width: '100%', maxWidth: '450px', margin: '0 auto' }}>
                    {/* --- Banner + Logo --- */}
                    <div style={{
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        height: '150px',
                        width: '100%',
                        backgroundImage: `url(${topImageUrl})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        borderRadius: '4px'
                    }}>
                        <img src={logo} alt="Logo" style={{
                            position: 'absolute',
                            marginLeft: '10px',
                            width: '40px',
                            height: '30px',
                            top: '110px',
                            zIndex: 2,
                        }} />
                    </div>

                    <div style={{ marginTop: "20px" }}>
                        {/* --- Campaign Info --- */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                            <div>
                                <p className="has-text-grey-light">Campaign Name</p>
                                <p className="has-text-weight-bold">{campaignName}</p>
                            </div>
                            <p className='has-text-weight-bold'>
                                Total Items For Review : <span style={{ color: '#3273dc' }}>{product?.length || 0}</span>
                            </p>
                            {product.length > 0 && product[0].maxItemsPerUser && (
                                <p className='has-text-weight-bold'>
                                    Items a User Can Review : <span style={{ color: '#23d160' }}>{product[0].maxItemsPerUser}</span>
                                </p>
                            )}
                            <div>
                                <p className="has-text-grey-light">Item Name</p>
                                {Object.entries(countBy(product, "productName")).map(([name, count], idx) => (
                                    <p key={idx} className='has-text-weight-bold'>{name}</p>
                                ))}
                            </div>
                        </div>

                        {/* --- Slots --- */}
                        <div style={{ marginTop: "20px" }}>
                            <p className="has-text-grey-light">Available Slots</p>
                            {product?.slice(0, 10).map((item, index) => (
                                <p key={index} className='has-text-weight-bold'>{item.productSlot}</p>
                            ))}
                        </div>

                        {/* --- Buttons --- */}
                        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginTop: '20px' }}>
                            <button onClick={handleOrders} className="button is-small has-text-info">View Campaign Details</button>
                            <button
                                onClick={handleApplyDeliverables}
                                className="button is-small has-text-info"
                                disabled={appliedMap[campaignName]} // ✅ FIXED: Disable per campaign
                                title={appliedMap[campaignName] ? "You have already submitted the maximum allowed." : ""}
                            >
                                Participate
                            </button>
                            {hasRefundForm && (
                                <button onClick={handleConfirmation} className="button is-small has-text-info" disabled={refundFilled}>
                                    Add Refund Details
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Card;